import { Button, Chip, Tab, Tabs, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@nextui-org/react";
import { DocumentIcon, PaperAirplaneIcon, ChevronDownIcon, EyeIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import RootAdmin from "../../../components/layouts/RootAdmin";
import Information from "../../../components/fragments/admin/registration/information/Information";
import Draft from "../../../components/fragments/admin/registration/Draft";
import { useParams } from "react-router-dom";
import HeaderPage from "../../../components/elements/HeaderPage";
import { exportJsonINSW, getDetailRegistrasi, getFetcher, getPdfUrl, sendInsw, submitSK, putFetcherWithoutId, downloadPdfWithName } from "../../../services/api";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { getRoles, hasValidRole } from "../../../services/helpers";
import { roleName } from "../../../services/enum";
import DraftDireksi from "../../../components/fragments/admin/registration/DraftDireksi";
import { saveAs } from "file-saver";
import Validation from "../../../components/fragments/admin/registration/information/Validation";
import useSWR from "swr";
import StatusPermohonanRegistrasi from "../../../enums/statusRegistrasi";
import useAuth from "../../../hooks/useAuth";
import RolesAccess from "../../../enums/roles";
import UpdateINSW from "../../../components/fragments/admin/registration/UpdateINSW";

export default function DetailPage() {
  const { user, roles } = useAuth();
  const { id } = useParams();
  const { data: dataDetail, isLoading, mutate } = useSWR(`/api/registrasi/${id}`, getFetcher);
  const [activeTab, setActiveTab] = useState("informasi");
  const [isDraftLoading, setDraftLoading] = useState(false);

  const [isSubmittingINSW, setIsSubmittingINSW] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isSubmittingDraft, setIsSubmittingDraft] = useState(false);

  const onSubmit = async () => {
    setIsSubmittingINSW(true);
    try {
      const dataInsw = {
        id: id,
        status: "riwayat",
        approval_status: "selesai",
        jnsPengajuan: "0100000000",
      };
      const response = await sendInsw(dataInsw);
      // const data = {
      //     id: id,
      //     status: StatusPermohonanRegistrasi.SELESAI,
      //     userId: user.userId,
      // }
      // await putFetcherWithoutId(`/api/registrasi/update-status-registrasi`, data);
      mutate();
      toast.success("Berhasil Kirim ke INSW");
    } catch (error) {
      console.log("error fetching:", error);
      toast.error("Gagal Kirim INSW :" + error?.response?.data?.message?.message);
    } finally {
      setIsSubmittingINSW(false); // Set loading end
    }
  };

  const onSubmitDraft = async () => {
    setIsSubmittingDraft(true);
    try {
      const response = await submitSK(id);
      toast.success("Berhasil Submit Data Draft SK");
      mutate();
    } catch (error) {
      console.log("error fetching:", error);
      toast.error(error.response.data.message);
    } finally {
      setIsSubmittingDraft(false); // Set loading end
    }
  };

  const onPressExport = async () => {
    setIsExporting(true);
    const data = {
      id: id,
      jnsPengajuan: "0100000000",
    };
    try {
      const response = await exportJsonINSW(data);
      const blob = new Blob([JSON.stringify(response, null, 2)], { type: "application/json" });
      saveAs(blob, "data-export.json");
      toast.success("Berhasil Export JSON");
      console.log(response, "success");
    } catch (error) {
      toast.error("Gagal Export JSON!");
      console.log("error fetching:", error);
    } finally {
      setIsExporting(false); // Set loading end
    }
  };

  const fetchPreview = async (endpoint) => {
    try {
      await getPdfUrl(endpoint);
    } catch (error) {
      toast.error("Failed to open PDF");
    }
  };

  const handleTabChange = (tabId) => {
    const selectedTab = tabs.find((tab) => tab.id === tabId);
    if (selectedTab && !selectedTab.disabled) {
      setActiveTab(tabId); // Only update activeTab if the tab is not disabled
    }
  };

  let tabs = [
    {
      id: "informasi",
      label: "Informasi",
      content: <Information dataB3={dataDetail} company={dataDetail} mutate={mutate} />,
    },
    {
      id: "validasi",
      label: "Validasi Dokumen PTSP",
      content: <Validation registrasi={dataDetail} />,
    },
    {
      id: "draft",
      label: "Draft SK",
      content: getRoles() === roleName.direksi ? <DraftDireksi id={id} /> : <Draft id={id} dataTembusan={dataDetail?.RegistrasiTembusan} mutate={mutate} data={dataDetail} />,
    },
    {
      id: "insw",
      label: "Update INSW",
      content: <UpdateINSW id={id} mutate={mutate} data={dataDetail} />,
    },
  ];

  const openPdfDirectly = async (endpoint, setLoadingState) => {
    setLoadingState(true);
    try {
      await getPdfUrl(endpoint);
    } catch (error) {
      toast.error("Failed to open PDF");
    } finally {
      setLoadingState(false);
    }
  };

  return (
    <RootAdmin>
      <HeaderPage
        title={dataDetail?.no_reg}
        subtitle="No. Reg. Bahan B3"
        action={
          <div className="flex items-center gap-3">
            <Chip size="sm" variant="bordered" color="primary" className={"capitalize"}>
              {dataDetail?.status}
            </Chip>
            {dataDetail?.status === StatusPermohonanRegistrasi.KIRIM_INSW && hasValidRole(roles, [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]) && (
              <Button startContent={<PaperAirplaneIcon className="size-4" />} size="sm" color="primary" onPress={onSubmit} isLoading={isSubmittingINSW}>
                Kirim INSW
              </Button>
            )}
            {dataDetail?.status === StatusPermohonanRegistrasi.KIRIM_INSW && hasValidRole(roles, [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]) && (
              <Button startContent={<PaperAirplaneIcon className="size-4" />} size="sm" color="primary" onPress={onPressExport} isLoading={isExporting}>
                Export
              </Button>
            )}
            {dataDetail?.status === StatusPermohonanRegistrasi.DRAFT_SK_TANDA_TANGAN_DIREKTUR && hasValidRole(roles, [RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR]) && (
              <Button startContent={<PaperAirplaneIcon className="size-4" />} size="sm" color="primary" onPress={onSubmitDraft} isLoading={isSubmittingDraft}>
                Submit Draft
              </Button>
            )}
            {dataDetail?.status != StatusPermohonanRegistrasi.VERIFIKASI_TEKNIS && hasValidRole(roles, [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_REGISTRASI, RolesAccess.DIREKTUR]) && (
              <Dropdown>
                <DropdownTrigger>
                  <Button size="sm" color="primary" startContent={<DocumentIcon className="size-4" />} endContent={<ChevronDownIcon className="size-3" />} isLoading={isDraftLoading} isDisabled={isDraftLoading}>
                    {isDraftLoading ? "Memuat..." : "Draft SK"}
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  aria-label="Draft SK options"
                  onAction={(key) => {
                    const srikandi = window.srikandiFormat || false;
                    const srikandiParam = srikandi ? "?srikandi=true" : "?srikandi=false";
                    if (key === "preview") {
                      openPdfDirectly(`/api/pdf/generateRegistrasiB3/${id}${srikandiParam}`, setDraftLoading);
                    } else if (key === "download") {
                      setDraftLoading(true);
                      downloadPdfWithName(`/api/pdf/generateRegistrasiB3/${id}${srikandiParam}`).finally(() => setDraftLoading(false));
                    }
                  }}
                >
                  <DropdownItem key="preview" startContent={<EyeIcon className="size-4" />} className="text-primary">
                    Lihat PDF
                  </DropdownItem>
                  <DropdownItem key="download" startContent={<ArrowDownTrayIcon className="size-4" />} className="text-primary">
                    Download PDF
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )}
          </div>
        }
      />
      <div className="flex w-full flex-col justify-between pt-5">
        <Tabs color="primary" radius="sm" size="md" variant="bordered" aria-label="form" selectedKey={activeTab} onSelectionChange={(key) => handleTabChange(key)}>
          {tabs.map((tab) => (
            <Tab key={tab.id} title={tab.label}>
              {tab.content}
            </Tab>
          ))}
        </Tabs>
      </div>
    </RootAdmin>
  );
}
